import PropTypes from 'prop-types';
import React from 'react';
import { Icon } from '@pwc/pwc-deals-ui';
import Separator from '../../../../common/components/Separator';
import './notes-display.scss';

const NotesDisplay = ({ text }) => (
  <div className="notes-display-view" data-testid="notes-display">
    {text && (
      <>
        <Icon name="note" className="fill" width={12} /> Footnotes (optional){' '}
        <Separator />
        <div className="notes-text">{text}</div>
      </>
    )}
  </div>
);

NotesDisplay.propTypes = {
  text: PropTypes.string.isRequired,
};

export default NotesDisplay;
